var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEllipseLeftBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 680,
    height: 267,
    viewBox: "0 0 680 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_42_178)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 97,
    r: 288,
    fill: "url(#paint0_linear_42_178)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_42_178",
    x: -248,
    y: -671,
    width: 1536,
    height: 1536,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 240,
    result: "effect1_foregroundBlur_42_178"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_178",
    x1: 161.622,
    y1: 261.204,
    x2: 940.404,
    y2: -330.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C42A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B6EFE",
    stopOpacity: 0.06
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEllipseLeftBg);
export default __webpack_public_path__ + "static/media/ic_ellipse_left_bg.0454eea9b87c8f7e46a30b4caa716345.svg";
export { ForwardRef as ReactComponent };